'use strict';

var GridHostShareDropdownDirective = function GridHostShareDropdownDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    transclude: false,
    template: require('../templates/grid-host-share-dropdown.html'),
    link: function link(scope, $element) {
      var gridPanel = scope.gridPanelScope.$parent;
      scope.setState = function () {
        scope.isDisabledButton = gridPanel.getSelectedRows().length > 0;
        scope.$broadcast('host-share:dropDownEvent', scope.isDisabledButton);
      };
    }
  };
};
GridHostShareDropdownDirective.$inject = [];
module.exports = GridHostShareDropdownDirective;